import { defineStore } from 'pinia'
import localforage from 'localforage'

export const useOutboxStore = defineStore('outbox', {
    state: () => ({
        queue: [], // { url, method, body, headers }
        processing: false,
    }),
    getters: {
        count: (state) => state.queue.length,
    },
    actions: {
        async init() {
            this.queue = (await localforage.getItem('outbox')) || []
            window.addEventListener('online', this.flush)
        },

        async addRequest(req) {
            this.queue.push(req)
            await localforage.setItem('outbox', this.queue)
        },

        async flush() {
            if (this.processing || !navigator.onLine) return
            this.processing = true

            while (this.queue.length > 0) {
                const req = this.queue[0]
                try {
                    await fetch(req.url, {
                        method: req.method,
                        headers: req.headers,
                        body: req.body ? JSON.stringify(req.body) : undefined,
                    })
                    this.queue.shift()
                    await localforage.setItem('outbox', this.queue)
                } catch (e) {
                    console.warn('Still offline or server error, stopping flush')
                    break
                }
            }

            this.processing = false
        },
    },
})
